import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from "axios";
import {
  FiBell,
  FiLogOut,
  FiSettings,
  FiUser
} from "react-icons/fi";
import useTranslations from "../../../hooks/useTranslations"; //  Çeviri için
import useUserLanguage from "../../../hooks/useUserLanguage"; //  Kullanıcının dilini almak için

const ProfileModal = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [userId, setUserId] = useState(null); // Kullanıcı ID

  //  Kullanıcının dilini al
  const language = useUserLanguage();
  const { translations } = useTranslations(language);

  //  getText fonksiyonu (Anahtar yoksa varsayılan metni göster)
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  useEffect(() => {
    if (!user) {
      fetchUserProfile();
    }
  }, [user]); //  Kullanıcı bilgisi boşsa API çağrısını sadece bir kez yap
  

  const fetchUserProfile = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      if (!token) return;

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/profile`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("🔹 Kullanıcı Bilgisi:", response.data);
      console.log("Admin ID:", localStorage.getItem("admin_id"));

      setUser(response.data); // Kullanıcı bilgilerini state'e kaydet
      setUserId(response.data.id);
    } catch (error) {
      console.error("❌ Kullanıcı bilgileri çekilemedi:", error);
    }
  };

  //  Dropdown'u kapatma fonksiyonu
  const closeDropdown = () => {
    const dropdown = document.querySelector(".nxl-h-dropdown");
    if (dropdown) {
      dropdown.classList.remove("show");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("admin_token"); // Token temizle
    navigate("/authentication/login/creative"); // Login sayfasına yönlendir
  };

  return (
    <div className="dropdown nxl-h-item">
      <a href="#" data-bs-toggle="dropdown" role="button" data-bs-auto-close="outside">
      <img
        src={user?.adminImage 
          ? `${process.env.REACT_APP_API_BASE_URL}${user.adminImage}`  // 🔹 Tam URL ekle
          : `${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg` // 🔹 Varsayılan resim
        }
        alt="Profil"
        onError={(e) => (e.target.src = `${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg`)} // 🔹 Hata olursa default avatar
        style={{
          width: "45px",
          height: "45px",
          borderRadius: "50%",
          objectFit: "cover",
          border: "1px solid #ddd"
        }}
      />

      </a>
      
      <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown">
        <div className="dropdown-header">
          {user ? (
            <div className="d-flex align-items-center">
              <img
                src={user?.adminImage 
                  ? `${process.env.REACT_APP_API_BASE_URL}${user.adminImage}`  // 🔹 Tam URL ekle
                  : `${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg` // 🔹 Varsayılan resim
                }
                alt="Profil"
                onError={(e) => (e.target.src = `${process.env.REACT_APP_API_BASE_URL}/uploads/avatars/default.svg`)} // 🔹 Hata olursa default avatar
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "1px solid #ddd"
                }}
              />

              <div className="ms-2">
                <h6 className="text-dark mb-0">
                  {user.first_name} {user.last_name}{" "}
                  <span className="badge bg-soft-success text-success ms-1">
                    {user.role_name} {/* Dinamik rol adı */}
                  </span>
                </h6>
                <span className="fs-12 fw-medium text-muted">{user.email}</span>
              </div>
            </div>
          ) : (
            <p>{getText("LOADING_USER")}</p>
          )}
        </div>

        <Link to={`/leads/view/${localStorage.getItem("admin_id")}`} className="dropdown-item" onClick={closeDropdown}>
          <i><FiUser /></i>
          <span>{getText("PROFILE_DETAILS")}</span>
        </Link>

        <Link to={`/profile/edit/${localStorage.getItem("admin_id")}`} className="dropdown-item" onClick={closeDropdown}>
          <i><FiSettings /></i>
          <span>{getText("ACCOUNT_SETTINGS")}</span>
        </Link>

        <div className="dropdown-divider"></div>

        <button onClick={handleLogout} className="dropdown-item">
          <i><FiLogOut /></i>
          <span>{getText("LOGOUT")}</span>
        </button>
      </div>
    </div>
  );
};

export default ProfileModal;
